export default "<p>serverinfo works!</p>\r\n";